// extracted by mini-css-extract-plugin
module.exports = {"title":"Rankings_title__1NMH7","rankings":"Rankings_rankings__3XuR5","rankingOL":"Rankings_rankingOL__2heD6","rankingLI":"Rankings_rankingLI__2qCp_"};